import { permit, permitApp, addCurrencyUnit, addCurrencySymbol, permitCountry } from "./tools";
import dayjs from "dayjs";
import { emptyToLine, splitThousands } from "./common";
import appCode from "@common/src/utils/app-code";
export function Table(loadDataMethodName = "loadListData", options = { pageSize: 10 }) {
  return function (target) {
    function loadData(target) {
      loadDataMethodName && target[loadDataMethodName]();
    }
    target.prototype.mix_pageNum = 1;
    target.prototype.mix_pageSize = options.pageSize || 10;
    target.prototype.mix_total = 0;
    target.prototype.mix_loading = false;
    target.prototype.mix_sortParams = [
      {
        item: "",
        type: ""
      }
    ];
    target.prototype.mix_handleSizeChange = function (size) {
      this.mix_pageNum = 1;
      this.mix_pageSize = size;
      loadData(this);
    };
    target.prototype.mix_handlePageChange = function (pageNum) {
      this.mix_pageNum = pageNum;
      loadData(this);
    };
    target.prototype.mix_handleTableSort = function ({ prop, order }) {
      this.mix_pageNum = 1;
      this.mix_sortParams = [
        {
          item: order ? prop : "",
          type: order ? (order === "ascending" ? "asc" : "desc") : ""
        }
      ];
      loadData(this);
    };
  };
}

Table.LoadDataMethod = function () {
  return function (target, name, descriptor) {
    const func = descriptor.value;
    descriptor.value = async function (...args: any[]) {
      this["mix_loading"] = true;
      try {
        const result = await func.apply(this, args);
        if (typeof result === "number") {
          this.mix_total = result;
        } else {
          this.mix_total = result.data.total;
        }
        return result;
      } catch (e) {
        this.mix_total = 0;
        console.error("Pagination data format is wrong");
      } finally {
        this["mix_loading"] = false;
      }
    };
  };
};

Table.DataImport = function (options) {
  return function (target) {
    target.prototype.mix_showImportModal = false;
    target.prototype.mix_templateUrl = options.templateUrl || "";
    target.prototype.mix_actionUrl = options.actionUrl;
    target.prototype.mix_templateCode = options.templateCode;
    target.prototype.mix_handleShowImportModal = function () {
      this.mix_showImportModal = true;
    };
    target.prototype.mix_handlehideImportModal = function () {
      this.mix_showImportModal = false;
    };
  };
};

interface TableRowsSelectOptions {
  warningMsg: string;
  updateStatusFuncName: string;
  tableRefKey: string;
  checkableFuncName?: string;
}
export function TableRowsSelect(options: TableRowsSelectOptions) {
  return function (target) {
    target.prototype.mix_showForbidTips = false;
    target.prototype.mix_selectedRows = [];
    target.prototype.mix_handleBatchForbid = function () {
      if (this.mix_selectedRows.length < 1) {
        this.$message.warning(options.warningMsg);
      } else {
        this.mix_showForbidTips = true;
      }
    };
    target.prototype.mix_handleBatchStart = function () {
      if (this.mix_selectedRows.length < 1) {
        this.$message.warning(options.warningMsg);
      } else {
        this[options.updateStatusFuncName](1);
      }
    };
    target.prototype.mix_handleCheckAll = function (tableDataList) {
      tableDataList.forEach(item => {
        if (options.checkableFuncName) {
          this[options.checkableFuncName](item) &&
            (this.$refs[options.tableRefKey] as any).toggleRowSelection(item, true);
        } else {
          (this.$refs[options.tableRefKey] as any).toggleRowSelection(item, true);
        }
      });
    };
    target.prototype.mix_handleCancelAll = function () {
      (this.$refs[options.tableRefKey] as any).clearSelection();
    };
    target.prototype.mix_handleRowSelect = function (selection) {
      this.mix_selectedRows = selection;
    };
  };
}

TableRowsSelect.updateMethod = function (target, name, descriptor) {
  const func = descriptor.value;
  descriptor.value = async function (...args: any[]) {
    try {
      const result = await func.apply(this, args);
      return result;
    } catch (e) {
      console.log("TableRowsSelect.updateCallback", e);
    } finally {
      this["mix_showForbidTips"] = false;
    }
  };
};

TableRowsSelect.checkableMethod = function (target, name, descriptor) {
  const func = descriptor.value;
  descriptor.value = async function (...args: any[]) {
    try {
      const result = await func.apply(this, args);
      return result;
    } catch (e) {
      console.log("TableRowsSelect.checkableMethod", e);
    } finally {
      //
    }
  };
};

export function InjectFunction(...funcNameArr) {
  const funcMap = {
    permit,
    dayjs,
    emptyToLine,
    splitThousands,
    addCurrencyUnit,
    permitApp,
    appCode,
    permitCountry,
    addCurrencySymbol
  };
  return function (target) {
    funcNameArr.forEach(name => {
      target.prototype[name] = funcMap[name];
    });
  };
}
